module.exports = __webpack_public_path__ + "img/product-1.755e8996.jpg";